import { render } from "./PantryDetailTitleView.vue?vue&type=template&id=09bd37ca&ts=true"
import script from "./PantryDetailTitleView.vue?vue&type=script&lang=ts"
export * from "./PantryDetailTitleView.vue?vue&type=script&lang=ts"

import "./PantryDetailTitleView.vue?vue&type=style&index=0&id=09bd37ca&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__